import { getTensorCoreUtilization } from '@/features/monitoring/api/prometheusApi';

import { createGpuMetricHook } from './createGpuMetricHook';

/**
 * Tensor Core 활용률 조회 Hook
 */
export const useTensorCoreUtilization = createGpuMetricHook('tensor-core-utilization', getTensorCoreUtilization);
